(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  class PivotCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.ACTIVE_CLASS = 'pivot-collection-tabs__active';
      this.ACTIVE_TAB_CLASS = 'pivot-collection-tabs__tab--active';
      this.tabs = [...this.querySelectorAll('.pivot-collection-tabs__tab')];
      this.isButtonsStyle = this.classList.contains('pivot-menu-buttons');
    }
    connectedCallback() {
      if (!this.isConnected) return;
      this.tabs.forEach((btn) =>
        btn.addEventListener('click', (e) => {
          const currentTab = this.querySelector(`.pivot-collection-tabs__tab.${this.ACTIVE_TAB_CLASS}`);
          const newTab = e.target.closest('button');
          const currentSection = this.querySelector(`.pivot-collection-tabs__collection-carousel.${this.ACTIVE_CLASS}`);
          const newActiveSection = this.querySelector(
            `.pivot-collection-tabs__collection-carousel#${newTab.dataset.tab}`
          );
          if (currentSection) currentSection.classList.remove(this.ACTIVE_CLASS);
          if (currentTab) {
            currentTab.classList.remove(this.ACTIVE_TAB_CLASS);
            if (this.isButtonsStyle) currentTab.classList.add('button--secondary');
          }
          if (newActiveSection) newActiveSection.classList.add(this.ACTIVE_CLASS);
          if (newTab) {
            newTab.classList.add(this.ACTIVE_TAB_CLASS);
            if (this.isButtonsStyle) newTab.classList.remove('button--secondary');
          }
        })
      );
    }
  }
  if (!customElements.get('pivot-collection-tabs')) {
    customElements.define('pivot-collection-tabs', PivotCollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-product-description"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('div.active');
          if (currentSectionActive) currentSectionActive.classList.remove('active');

          const selector = `div[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          console.log(selector, newSectionActive);
          if (newSectionActive) newSectionActive.classList.add('active');
        });
      });
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  class PivotJsonTable extends HTMLElement {
    constructor() {
      super();
      const data = JSON.parse(this.textContent);
      console.log(data);
      let code = `<table>
        ${Object.entries(data).reduce((acc, [k, v]) => {
          return `${acc} 
          <tr>
            <td>${k}</td>
            <td>${v}</td>
          </tr>`;
        }, '')}
        </table>`;
      this.innerHTML = code;
    }
  }
  if (!customElements.get('pivot-json-table')) {
    customElements.define('pivot-json-table', PivotJsonTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-product-details"] && !Shopify.designMode) return;
  try {
    
  class PivotProductDescription extends HTMLElement {
    constructor() {
      super();
      this.$triggersWrapper = this.querySelector('.pivot-product-description__tabs');
      this.$$triggers = this.$triggersWrapper.querySelectorAll('button');
      this.$contentsWrapper = this.querySelector('.pivot-product-description__contents');

      this.$$triggers.forEach((button) => {
        button.addEventListener('click', (e) => {
          const currentActive = this.$triggersWrapper.querySelector('button.active');
          if (currentActive) currentActive.classList.remove('active');
          button.classList.add('active');

          const currentSectionActive = this.$contentsWrapper.querySelector('details[open]');
          if (currentSectionActive) currentSectionActive.open = false;

          const selector = `details[data-link="${button.dataset.link}"]`;
          const newSectionActive = this.$contentsWrapper.querySelector(selector);
          if (newSectionActive) newSectionActive.open = true;
        });
      });
    }
  }
  if (!customElements.get('pivot-product-description')) {
    customElements.define('pivot-product-description', PivotProductDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pivot-store-attributes"] && !Shopify.designMode) return;
  try {
    
  class PivotStoreAttributes extends HTMLElement {
    constructor() {
      super();
      this.dkColumns = Number(this.getAttribute('dk-columns') || 1);
      this.mbColumns = Number(this.getAttribute('mb-columns') || 1);
      this.dkCarousel = this.getAttribute('dk-carousel') === 'true';
      this.mbCarousel = this.getAttribute('mb-carousel') === 'true';
      this.dkArrows = this.getAttribute('dk-arrows') === 'true';
      this.mbArrows = this.getAttribute('mb-arrows') === 'true';
      this.enableDivider = this.getAttribute('enable-divider') === 'true';
      this.paginationColorScheme = this.dataset.paginationColorScheme;
    }
    async connectedCallback() {
      if (!this.isConnected) return;
      await import('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js');
      const config = {
        perPage: this.dkColumns,
        gap: this.enableDivider ? '2rem' : '4rem',
        destroy: !this.dkCarousel,
        arrows: this.dkArrows,
        breakpoints: {
          750: {
            perPage: this.mbColumns,
            gap: this.enableDivider ? '1rem' : '2rem',
            destroy: !this.mbCarousel,
            arrows: this.mbArrows,
          },
        },
      };

      console.log('Config', config);

      this.splide = new Splide(this.querySelector('.splide'), config);
      this.splide.on('mounted', () => {
        const pagination = this.querySelector('.splide__pagination');
        pagination.classList.add(`color-${this.paginationColorScheme}`);
      });
      this.splide.mount();
    }
  }
  if (!customElements.get('pivot-store-attributes')) {
    customElements.define('pivot-store-attributes', PivotStoreAttributes);
  }

  } catch(e) { console.error(e); }
})();
})();
